var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyPackagesAddPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 122,
    height: 122,
    rx: 61,
    fill: "url(#paint0_linear_4136_297873)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0516 47.0994V43.9852C47.0516 36.7616 52.8627 29.6663 60.0863 28.9921C62.0935 28.7949 64.1197 29.0201 66.0345 29.6532C67.9494 30.2864 69.7104 31.3134 71.2044 32.6683C72.6983 34.0231 73.8921 35.6757 74.7088 37.5198C75.5255 39.3638 75.947 41.3584 75.9463 43.3752V47.8058M51.8674 93.1063H71.1306C84.0369 93.1063 86.3485 87.9373 87.0227 81.6447L89.4306 62.3816C90.2974 54.5479 88.05 48.1589 74.3411 48.1589H48.6569C34.9479 48.1589 32.7006 54.5479 33.5674 62.3816L35.9753 81.6447C36.6495 87.9373 38.9611 93.1063 51.8674 93.1063Z",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7208 61H72.7529M50.2471 61H50.2728",
    stroke: "#0061AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4136_297873",
    x1: 61.5,
    y1: 0,
    x2: 61.5,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPackagesAddPackage);
export default __webpack_public_path__ + "static/media/empty-packages_add-package.4d0bcd159a9fd03e2677adf107a1bd36.svg";
export { ForwardRef as ReactComponent };